module.exports = __webpack_public_path__ + "images/course-2x.82753bf27d4a66321c855838c0bdc733.png";